import { API } from 'config';

function CompanyService($http, $resource, $mdDialog, $tszToast) {

  'ngInject';

  const CompanyResource = $resource(API.COMPANIES, { id: '@id' }, {
    get: {
      method: 'GET',
    },
    create: {
      method: 'POST',
    },
    update: {
      method: 'PUT',
    },
    delete: {
      method: 'DELETE',
    },
    list: {
      method: 'GET',
      isArray: true,
    },
    invite: {
      method: 'POST',
      url: API.COMPANY.USERS,
    },
    users: {
      method: 'GET',
      url: API.COMPANY.USERS,
      isArray: true,
    },
    get_payment_details: {
      method: 'POST',
      url: API.COMPANY.REPORT,
    },
  });

  return {
    get: (id) => CompanyResource.get({ id }).$promise,
    create: (company) => CompanyResource.create(company).$promise,
    update: (id, company) => CompanyResource.update({ id }, company).$promise,
    delete: (id) => CompanyResource.delete({ id }).$promise,
    invite: (id, invitation) => CompanyResource.invite({ id }, invitation).$promise,
    list: () => CompanyResource.list().$promise,
    users: (id) => CompanyResource.users({ id }).$promise,

    getPaymentDetails: (companyId, reportId) =>
      CompanyResource.get_payment_details({ companyId, reportId }, {}).$promise,

    deleteAction: (company, ev, callback) => {

      let companyName = company.name;
      if (!companyName) {
        companyName = company.id;
      }

      const confirm = $mdDialog.confirm()
            .clickOutsideToClose(true)
            .title('Estás seguro de que quieres eliminar esta compañía?')
            .textContent(`Esta operación eliminará de forma irreversible la compañía "${companyName}"`)
            .ariaLabel('Confirmar eliminación compañía')
            .targetEvent(ev)
            .ok('Eliminar')
            .cancel('Cancelar');

      $mdDialog.show(confirm)
      .then(() => {
        CompanyResource.delete({ id: company.id }).$promise
        .then(() => {
          $tszToast.showSuccess(`La compañía "${companyName}" ha sido eliminada`);
          callback(company.id);
        }).catch((err) => {
          console.error(err.message);
          $tszToast.showError(`Se ha producido un error al eliminar la compañía "${companyName}"`);
        });
      });
    },
  };
}

export default CompanyService;



// WEBPACK FOOTER //
// ./src/services/Company.js